import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: #00C0DA;
  display: flex;
  justify-content: center;
  padding: 80px 32px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;
  }
`

export const Wrapper = styled.div`
  align-items: center;
  color: #FFFFFF;
  display: flex;
  gap: 105px;
  width: 100%;

  & > img {
    max-height: 526px;
    max-width: 100%;

    @media (max-width: 768px) {
      margin: 0 auto;
    }
  }

  @media (max-width: 1072px) {
    align-items: center;
    display: grid;
    grid-template-columns: 1fr;
  }
`

export const Responsible = styled.p`
  color: #FFFFFF;
  font-family: 'Ubuntu';
  font-size: 14px;
  line-height: 16px;
  margin-top: 30px;
  text-align: center;
`

export const Content = styled.div`
  & > h5 {
    margin-bottom: 16px;

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 36.77px;
    }
  }

  & > p {
    margin-bottom: 32px;
  }

  & > a {
    @media (max-width: 768px) {
      display: inline-flex;
      justify-content: center;
      padding: 8px 16px;
    }
  }
`

export const Grid = styled.div`
  color: #FFFFFF;
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 46px;
  padding-right: 56px;

  @media (max-width: 768px) {
    padding: 0;
    grid-template-columns: repeat(2, 1fr);
  }
`

export const Card = styled.div`
  background-color: #00ABC2;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  height: 100%;
  padding: 12px 16px;
  width: 100%;

  & > img {
    width: 32px;
  }

  & > p {
    font-family: 'Source Sans 3';
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
  }
`
